import styled from 'styled-components'
import { theme } from 'design-cannect'

interface ContainerProps {
  isColumn?: boolean
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: ${({ isColumn }) => (isColumn ? 'column' : null)};
  align-items: center;

  gap: 30px;

  padding: 64px 0 40px 0;
`

export const Header = styled.div`
  display: flex;
  justify-content: center;

  width: 100%;
`

export const NavigatorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 5px;

  float: right;
`

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;

  cursor: pointer;
`

export const SubmitButton = styled.button`
  display: flex;

  background-color: #ecece2;
  color: ${theme.colors.tertiary};

  border-radius: 0.5rem;
  border: 1px solid;
  border-bottom-width: 5px;
  border-color: #DADAC2;

  margin-top: 50px;
  padding: 1rem;

  cursor: pointer;

  height: 48px
  transition: transform 0.2s;

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }

  &:hover {
    transform: scale(1.03);
  }
`
